import React from 'react'
import { Box, Card, Flex, Button } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'
import columnSizeMatcher from '@components/utils/columnSizeMatcher'
import Body from './Card.Body'
import Footer from './Card.Footer'
import Media from './Card.Media'

const styles = {
  card: {
    overflow: `hidden`,
    height: `full`
  },
  content: {
    alignItems: `stretch`,
    height: `full`
  }
}

const CardBase = ({
  columns,
  onMouseOver,
  isPartner,
  isHeritage,
  isTagBlog,
  isSymposium,
  linkKey,
  ...props
}) => {
  const getWidth = () => {
    return {maxWidth:'50% !important'}
  }

  return (
    <Box
      className='blog_card'
      sx={props.callFrom !== 'Event' ? columnSizeMatcher(columns) : getWidth()}
      onMouseOver={onMouseOver}
      onFocus={onMouseOver}
    >
      <Card
        style={isHeritage || isSymposium ? { padding: '20px' } : {}}
        variant='interactive'
        sx={{
          ...styles.card,
          variant: rv(props.variant, 'card')
        }}
      >
        <Flex
          as='article'
          sx={{
            ...styles.content,
            variant: rv(props.variant, 'content')
          }}
          style={isHeritage || isSymposium ? { alignItems: 'flex-start' } : {}}
        >
          <Media
            {...props}
            isSymposium={isSymposium}
            isPartner={isPartner}
            isHeritage={isHeritage}
            isTagBlog={isTagBlog}
            linkKey={linkKey}
          />
          <Body
            {...props}
            isHeritage={isHeritage}
            isSymposium={isSymposium}
            isTagBlog={isTagBlog}
            linkKey={linkKey}
          >
            {!isPartner ? <Footer {...props} /> : <></>}
          </Body>
        </Flex>
      </Card>
    </Box>
  )
}

export default CardBase
